import React, { Component } from 'react';
import { Formik, FieldArray } from 'formik';
import { Alert, Button, Dialog, Heading, Pane, Text, TextInputField, SelectField } from 'evergreen-ui';

// One modal backs both "colet suplimentar" (extra) and "colet la schimb"
// (exchange/swap). They share the package + pickup-point form; exchange hides
// the COD field (a swap is never cash-on-delivery) and explains the swap.
class ShipmentFormModal extends Component {
    onClose = () => {
        this.props.onClose();
    }

    render () {
        const isExchange = this.props.mode === 'exchange';
        const title = isExchange ? 'Colet la schimb' : 'Trimite colet suplimentar';

        return (<Dialog
            shouldCloseOnOverlayClick={false}
            width={700}
            isShown={this.props.open}
            title={title}
            hasFooter={false}
            onCloseComplete={this.onClose}
            onClose={this.onClose}>

            <Pane>
                <Formik
                    initialValues={{
                        packages: [{ width: 10, height: 10, length: 10 }],
                        pickupPoint: 'PLOIESTI',
                        cod: 0
                    }}
                    enableReinitialize={true}
                    validateOnChange={false}
                    validateOnBlur={false}
                    onSubmit={(values) => {
                        this.props.onSubmit(values);
                        this.props.onClose();
                    }}
                >
                    {({ handleChange, handleBlur, handleSubmit, values }) => (
                        <form>
                            {isExchange ?
                                <Alert
                                    intent="none"
                                    title="Curierul preda coletul si ridica un colet de la client. Sameday genereaza automat si AWB-ul de retur."
                                    marginBottom={16}
                                /> : null}

                            <Heading size={400}>Dimensiuni colete</Heading>
                            <Text color="muted">Introdu dimensiunile coletelor expediate</Text>
                            <FieldArray name="packages" render={arrayHelpers => (
                                <Pane marginTop={10}>
                                    <Button type="button" onClick={() => arrayHelpers.push({ width: 10, height: 10, length: 10 })}>Adauga colet</Button>
                                    {values.packages.map((pkg, i) => (
                                        <Pane display="flex" marginTop={10} key={i}>
                                            <TextInputField
                                                width={150}
                                                marginRight={5}
                                                required
                                                label="Latime (cm)"
                                                name={`packages.${i}.width`}
                                                value={pkg.width || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            <TextInputField
                                                width={150}
                                                marginRight={5}
                                                required
                                                label="Lungime (cm)"
                                                name={`packages.${i}.length`}
                                                value={pkg.length || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            <TextInputField
                                                width={150}
                                                marginRight={5}
                                                required
                                                label="Inaltime (cm)"
                                                name={`packages.${i}.height`}
                                                value={pkg.height || ''}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                            />
                                            <Button type="button" onClick={() => arrayHelpers.remove(i)} marginTop={24} intent="danger">X</Button>
                                        </Pane>
                                    ))}
                                </Pane>
                            )} />

                            <Pane marginTop={10}>
                                <SelectField
                                    label="Locatie Ridicare"
                                    name="pickupPoint"
                                    value={values.pickupPoint}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                >
                                    <option value="PLOIESTI">Ploiesti</option>
                                    <option value="BRASOV">Brasov</option>
                                </SelectField>

                                {!isExchange ?
                                    <TextInputField
                                        width={200}
                                        label="Ramburs (Lei)"
                                        description="0 daca este deja achitat"
                                        name="cod"
                                        value={values.cod}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                    /> : null}
                            </Pane>

                            <Pane borderTop="default" marginTop={16} paddingTop={16}>
                                <Button type="submit" onClick={handleSubmit} disabled={values.packages.length === 0}>
                                    Genereaza AWB
                                </Button>
                            </Pane>
                        </form>
                    )}
                </Formik>
            </Pane>
        </Dialog>);
    }
}

export default ShipmentFormModal;
